<template lang="pug">
  v-layout(style="margin: 0 auto;")
    v-flex(:class="activeMethod")
      v-layout.box-card-mis-solicitudes(
        @click="clickCard"
        justify-space-around column fill-height
        @mouseover="changeImg(this)" @mouseleave="originalImg(this)"
        )
        v-flex.box-card-floating-mis-solicitudes(v-show="floatingText")
          span {{floatingText}}
        v-flex.box-card-text-mis-solicitudes
          span {{text}}
        v-flex.box-card-img-mis-solicitudes
          v-img
            img(:src="iconMain")
</template>

<script>

export default {
  props: [
    'text',
    'icon',
    'icon2',
    'iconHover',
    'floatingText',
    'activo'
  ],
  data () {
    return {
      iconMain: null
    }
  },
  computed: {
    activeMethod () {
      return this.activo ? '' : 'box-active-card-mis-solicitudes'
    }
  },
  mounted () {
    let self = this

    self.iconMain = self.icon

    if (self.icon2) {
      self.iconMain = self.activo ? self.icon : self.icon2
    }
  },
  methods: {
    clickCard () {
      this.$emit('cardMethod')
    },
    changeImg (element) {
      this.iconMain = this.icon2 || this.icon
    },
    originalImg (element) {
      if (this.icon2) {
        this.iconMain = this.activo ? this.icon : this.icon2
      }
    }

  }

}
</script>

<style scoped>
@media (min-width : 360px) {
  .box-active-card-mis-solicitudes .box-card-mis-solicitudes {
    background-color: #f9f9f9 !important;
  }

  .box-active-card-mis-solicitudes .box-card-text-mis-solicitudes span {
    color: #919191;
  }

  .box-card-mis-solicitudes:active {
    border: 1px solid #0855c4
  }

  .box-card-floating-mis-solicitudes {
    position: absolute;
    top: -12px;
    right: -13px;
    border-radius: 3em;
    width: 34px;
    height: 34px;
    background: var(--fuchsia-color);
  }

  .box-card-floating-mis-solicitudes span {
    color: #ffffff !important;
    font-size: 0.7em !important;
    display: flex;
    justify-content: center;
    height: inherit;
    align-items: center;
  }

  .box-card-mis-solicitudes {
    position: relative;
    box-sizing: border-box;
    border: 1px solid #F2F2F2;
    height: 9.6em !important;
    width: 10.6em !important;
    box-shadow: 0px 5px 9px rgb(164 164 164 / 10%);
    border-radius: 15px;
    padding-top: 20px;
    padding-left: 15px;
    padding-right: 12px;
    padding-bottom: 12px;
    cursor: pointer
  }

  .box-card-mis-solicitudes:hover {
    background-color: #f9f9f9;
  }

  .box-card-img-mis-solicitudes img {
    height: 35px !important;
    float: right
  }

  /* .box-card-text-mis-solicitudes {} */

  .box-card-text-mis-solicitudes span {
    font-size: 16px;
    color: var(--text-color);
    line-height: initial;
    display: flex;
  }

  .box-card-img-mis-solicitudes {
    text-align: right;
    display: flex;
    align-items: flex-end;
  }
}

@media (min-width : 1024px) {
  .box-card-mis-solicitudes {
    height: 8.4em !important;
    width: 9.4em !important;
    padding-top: 15px;
  }

  .box-card-text-mis-solicitudes span {
    font-size: 13px !important;
  }
}

@media (min-width : 1200px) {

  .box-card-floating-mis-solicitudes {
    width: 28px !important;
    height: 28px !important;
    top: -9px;
    right: -10px;
  }

  .box-card-floating-mis-solicitudes span {
    font-size: 0.6em !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mis-seguros/CardMisSolicitudes2.vue